import { __assign, __rest } from "tslib";
import React from 'react';
import VeltNotificationsPanelContentListItemWireframe from './VeltNotificationsPanelContentListItemWireframe/VeltNotificationsPanelContentListItemWireframe';
import { transformWireframeProps } from '../../../../utils/propUtils';
var VeltNotificationsPanelContentListWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-notifications-panel-content-list-wireframe", __assign({}, transformedProps), children));
};
VeltNotificationsPanelContentListWireframe.Item = VeltNotificationsPanelContentListItemWireframe;
export default VeltNotificationsPanelContentListWireframe;
